import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {},
    fc_35: {},
    loading: false,
    paginaActiva: 1,
    fc_35Map: {},
    modoVerDetalle:false,
    modoRecibidasCorregidas:false,
    modoProceso:false

}

//types
const OBTENER_FC_35_DETALLE_EXITO = 'OBTENER_FC_35_DETALLE_EXITO'
const ACTUALIZAR_FC_35_PAGINA = 'ACTUALIZAR_FC_35_PAGINA'
const ACTUALIZAR_FC_35_ESTATUS_EXITO = 'ACTUALIZAR_FC_35_ESTATUS_EXITO'
const AGREGAR_FC_35_EXITO_MAP = 'AGREGAR_FC_35_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_35_MAP_EXITO = 'OBTENER_FC_35_MAP_EXITO'
const ACTUALIZAR_FC_35_EXITO = 'AGREGAR_FC_35_EXITO'
const ACTUALIZAR_FC_35_MAP_EXITO = 'AGREGAR_FC_35_MAP_EXITO'
const GENERAR_OFICIOS_FC35_EXITO = 'GENERAR_OFICIOS_FC35_EXITO'
const ACTUALIZAR_FC_35_SOLICITUD_MODAL_EXITO = 'ACTUALIZAR_FC_35_SOLICITUD_MODAL_EXITO'

export const actualizarFC_35Estatus = createAsyncThunk(
    ACTUALIZAR_FC_35_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_35SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_35_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_35/obtenerFormatoFC35_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            return  res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapFC_35Accion = createAsyncThunk(
    AGREGAR_FC_35_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud}
            let archivosMap = data.archivosMap
            const agregarFC_35Map = host + 'MapSolicitud/agregarMapFC_35_NotificacionDeServiciosVariosMap'
            const agregarFC_35ArchivosMap = host + `MapSolicitud/agregarMapFC_35_ArchivosGenerales`
            const res = await axios.post(agregarFC_35Map, solicitud)
            for (const anexo of archivosMap) {
                await axios.post(agregarFC_35ArchivosMap, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_35Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_35_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivos = data.archivos

            const actualizarFC_35 = host + `FC_35/actualizarFormatoFC35`
            const urlActualizarArchivos = host + 'FC_35/actualizarArchivoFC_35'
            const res = await axios.put(actualizarFC_35, solicitud)
            for (const anexo in archivos) {
                let resAnexo = await axios.put(urlActualizarArchivos, { data: archivos[anexo] })
            }
            //return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_35Map = createAsyncThunk(
    OBTENER_FC_35_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_35_NotificacionDeServiciosVariosMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const Map = await obtenerAchivosMap(solicitudId)
            return { data: res.data.data, filesMap: Map.filesGeneralMap }
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerAchivosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_35/obtenerFormatoFC35_ConDetalle/${idSolicitud}`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_35_ArchivosGenerales/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_35archivos
        const filesGeneralMap = []

        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_35archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_35archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }
        let Map = { filesGeneralMap: filesGeneralMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_35SolicitudMap = createAsyncThunk(
    ACTUALIZAR_FC_35_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosMap = data.archivosMap
            const actualizarFC_35Map = host + `MapSolicitud/actualizarMapFC_35_NotificacionDeServiciosVariosMap`
            
            const urlAgregarArchivos = host + 'MapSolicitud/agregarMapFC_35_ArchivosGenerales'
            const urlActualizarArchivos = host + 'MapSolicitud/actualizarMapFC_35_ArchivosGenerales'
            const res = await axios.put(actualizarFC_35Map, { data: solicitud.data })
            for (let anexo of archivosMap) {
                if (anexo.idfc_35archivosmap != "" && anexo.idfc_35archivosmap != null && anexo.idfc_35archivosmap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivos, { data: anexo })
                } else {
                    delete anexo.idfc_35archivosmap
                    let resAnexo = await axios.post(urlAgregarArchivos, { data: anexo })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_35 = createAsyncThunk(
    GENERAR_OFICIOS_FC35_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)



export const actualizarFC_35MapSolicitud = createAsyncThunk(
    ACTUALIZAR_FC_35_MAP_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `MapSolicitud/actualizarMapFC_35_NotificacionDeServiciosVariosMap`
            const res = await axios.put(fullUrl, { data })
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

//Para guardar la información del modal en atención a clientes
export const actualizarFC_35SolicitudModal = createAsyncThunk(
    ACTUALIZAR_FC_35_SOLICITUD_MODAL_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }
            const actualizarFC_35 = host + `FC_35/actualizarFormatoFC35`
            const res = await axios.put(actualizarFC_35, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc35Slice = createSlice({
    name: 'fc35Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_35(state, { payload }) {
            state.paginaActiva = payload
        },
        resetDataFC_35(state, { payload }) {
            return dataInicial
        },
        setModoVerDetalleFC_35(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_35(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_35(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [obtenerFC_35SolicitudDetalle.fulfilled]: (state, {payload}) => {
            state.data = payload
        },
        [obtenerFC_35Map.fulfilled]: (state, { payload }) => {
            state.fc_35Map = payload?.data
            state.filesMap = payload?.filesMap
        },




        [agregarMapFC_35Accion.fulfilled]: (state, { payload }) => {

        },
        [actualizarFC_35Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        }, 
        
        [actualizarFC_35Solicitud.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_35MapSolicitud.fulfilled]: (state, { payload }) => {
        }, 
    },
})

export const { actualizarPaginaActivaFC_35,resetDataFC_35,
    setModoRecibidasCorregidasFC_35,setModoVerDetalleFC_35,
    setModoProcesoFC_35 } = fc35Slice.actions
export const FC35ReducerAtencionACliente = fc35Slice.reducer